import React, { useEffect, useState } from 'react';

import IconButton from '@liquidweb-dev/undercurrent/IconButton';
import MenuItem from '@liquidweb-dev/undercurrent/MenuItem';
import EllipsisIcon from '@liquidweb-dev/undercurrent/icons/lucide/Ellipsis';
import Menu from '@liquidweb-dev/undercurrent/Menu';
import Tooltip from '@liquidweb-dev/undercurrent/Tooltip';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import HookedLink from '../common/HookedLink';
import useLeftHandLayout from '../context';

/**
 * @param {React.ComponentProps<typeof IconButton>} props
 */
export function LeftNavFooterMenu(props) {
	const [menuElement, setMenuElement] = useState();
	const open = menuElement !== undefined;

	const { appPath } = useLeftHandLayout();

	// Close menu when appPath changes
	useEffect(() => {
		if (appPath === undefined) return;
		setMenuElement(undefined);
	}, [appPath]);

	return (
		<>
			<Tooltip title="Account" placement="top">
				<IconButton
					onClick={({ currentTarget }) => setMenuElement(currentTarget)}
					variant="barebones"
					{...props}
				>
					<EllipsisIcon sx={{ height: '16px', width: '16px' }} />
				</IconButton>
			</Tooltip>
			<Menu
				open={open}
				anchorEl={menuElement}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				onClose={() => setMenuElement()}
			>
				<MenuItem
					component={HookedLink}
					href="/account/billing/pay"
					role="menuitem"
				>
					<Typography component="span" variant="label-lg">
						Pay now
					</Typography>
				</MenuItem>
				<MenuItem
					component={HookedLink}
					href="/account/billing"
					role="menuitem"
				>
					<Typography component="span" variant="label-lg">
						Billing details
					</Typography>
				</MenuItem>
				<MenuItem component={HookedLink} href="/account" role="menuitem">
					<Typography component="span" variant="label-lg">
						Account settings
					</Typography>
				</MenuItem>
			</Menu>
		</>
	);
}

export default LeftNavFooterMenu;
